import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { InactivityCounter } from './inactivity.component';
import { CheckBoxModule, InputSubmitModule, ModalModule } from '../components';

@NgModule({
  declarations: [InactivityCounter],
  imports: [CommonModule, SharedModule, ModalModule, CheckBoxModule, InputSubmitModule],
  exports: [InactivityCounter]
})
export class InactivityModule {}
